<div class="modal-backdrop">
  <div class="modal-box">
    <h2>Are you still there?</h2>
    <p class="message">
      You’ve been inactive. You’ll be logged out in 
      <strong class="countdown">{{ countdown$ | async }}</strong> seconds.
    </p>
    <div class="actions">
      <button class="btn stay" (click)="stayLoggedIn()">Stay Logged In</button>
      <button class="btn logout" (click)="logout()">Log Out</button>
    </div>
  </div>
</div>
